// extracted by mini-css-extract-plugin
export var alertIcon = "_pa-0";